import { render, staticRenderFns } from "./RespondentOrientation.vue?vue&type=template&id=681fc4cd&scoped=true&"
import script from "./RespondentOrientation.vue?vue&type=script&lang=js&"
export * from "./RespondentOrientation.vue?vue&type=script&lang=js&"
import style0 from "./RespondentOrientation.vue?vue&type=style&index=0&id=681fc4cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fc4cd",
  null
  
)

export default component.exports